import moment from 'moment';

export const validate = (dob: string, errorMessage: string): boolean | string =>
  !Number(dob)
    ? false
    : moment(dob, 'DDMMYYYY', true).isValid() || errorMessage;

export const isDobValid = (dob: string): boolean =>
  !Number(dob) ? false : moment(dob, 'DDMMYYYY', true).isValid();

export const isDobInRange = (
  dob: string,
  minAge: number,
  maxAge: number
): boolean =>
  moment(dob, 'DDMMYYYY', true).isBetween(
    moment().subtract(maxAge, 'year'),
    moment().subtract(minAge, 'year')
  );

export const DateOfBirthQuestionValidators = {
  format: (value: string, errorMessage: string) =>
    validate(value, errorMessage),
  range: (
    value: string,
    minAge: number,
    maxAge: number,
    errorMessage: string
  ) => isDobInRange(value, minAge, maxAge) || errorMessage,
};
